import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { LoadingBarProcess } from 'components/loadingProcess/LoadingBarProcess'

const ResetPasswordPage = React.lazy(() => import("../../pages/resetPassword/ResetPasswordPage"));

const ResetPasswordRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={
                <React.Suspense fallback={<LoadingBarProcess />}>
                    <ResetPasswordPage />
                </React.Suspense>
            }>
            </Route>
        </Routes>
    )
}

export default ResetPasswordRoutes